import { render, staticRenderFns } from "./dialog_activityDetail.vue?vue&type=template&id=243418c8&scoped=true&"
import script from "./dialog_activityDetail.vue?vue&type=script&lang=js&"
export * from "./dialog_activityDetail.vue?vue&type=script&lang=js&"
import style0 from "./dialog_activityDetail.vue?vue&type=style&index=0&id=243418c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243418c8",
  null
  
)

export default component.exports